/* shani-product: גלריה (מונה, חיצים, ממוזערות, זום), מגירות (מצב, אמון, פריט יחיד), שורת הדירוג, פס דביק. השומר "כבר בסל": shani-cart-guard.js.
   ההוספה לסל עצמה עוברת במטפל של התבנית (theme.js, [data-btn-addToCart]). */
(function () {
  var root = document.querySelector('[data-shp]');
  if (!root) return;

  /* ===== גלריה ===== */
  var track = root.querySelector('[data-shp-track]');
  var cur = root.querySelector('[data-shp-cur]');
  var slides = track ? track.querySelectorAll('.shp-slide') : [];
  var thumbs = root.querySelectorAll('[data-shp-thumb]');
  var prevB = root.querySelector('.shp-nav--prev');
  var nextB = root.querySelector('.shp-nav--next');
  function slideAt(i) { return track ? track.querySelector('.shp-slide[data-i="' + i + '"]') : null; }
  function curIndex() {
    if (!track) return 1;
    var w = track.clientWidth || 1;
    return Math.min(slides.length, Math.round(Math.abs(track.scrollLeft) / w) + 1);
  }
  function syncUi() {
    var i = curIndex();
    if (cur && cur.textContent !== String(i)) cur.textContent = i;
    thumbs.forEach(function (t) { t.classList.toggle('is-on', t.getAttribute('data-shp-thumb') === String(i)); });
    /* build-h (בודק הקוד, בינוני 1): קודם מחזירים את החץ השני, ורק אז מסתירים. אחרת הפוקוס מנסה לעבור לחץ שעדיין hidden ונשאר על חץ עם aria-hidden */
    var offP = i <= 1, offN = i >= slides.length;
    if (offP) { setOff(nextB, offN, prevB); setOff(prevB, offP, nextB); }
    else { setOff(prevB, offP, nextB); setOff(nextB, offN, prevB); }
  }
  /* חץ בקצה, עיקרון אחד לגלריה, לזום ולרצועות (תיקוני גל ב, אורי 03.10): חץ שהגיע לקצה לא נעלם מיד מתחת לסמן.
     הוא נשאר במקומו, שקוף (is-gone), מחוץ לקורא המסך ולסדר ה-Tab, ובולע את הלחיצה, כדי שלחיצה חוזרת באותה נקודה לא תיפול על מה שמתחתיו
     (כרטיס = ניווט, תמונה = סגירת הזום). הוא יורד באמת (hidden) רק אחרי 600 מ"ש וגם כשהסמן כבר לא מעליו.
     גל ד (בודק הקוד): ":hover" נבדק רק במכשיר שיש לו סמן אמיתי (hover: hover). במסך מגע רחב (אייפד לרוחב) hover נשאר דולק אחרי הקשה,
     mouseleave לא נורה, והחץ השקוף היה ממשיך לבלוע הקשות. שם הוא יורד אחרי 600 מ"ש.
     לחיצה על חץ שקוף לא נותנת לו פוקוס (mousedown מבוטל): הוא aria-hidden, ופוקוס עליו מאבד את קורא המסך.
     אם הפוקוס היה על החץ, הוא עובר ל-other. כפתור מושבת (disabled) לא מתאים: base.css מעביר דרכו את הלחיצה. */
  function arrowDrop(b) {
    if (!b.classList.contains('is-gone') || !b._shpDue) return;
    var over = false;
    try { over = !!window.matchMedia && matchMedia('(hover: hover)').matches && b.matches(':hover'); } catch (e) {}
    if (!over) { b.hidden = true; b.classList.remove('is-gone'); }
  }
  function setOff(b, off, other) {
    if (!b) return;
    if (!b._shpArrow) {
      b._shpArrow = 1;
      b.addEventListener('mouseleave', function () { arrowDrop(b); });
      b.addEventListener('mousedown', function (e) { if (b.classList.contains('is-gone')) e.preventDefault(); });
    }
    if (!off) {
      clearTimeout(b._shpT);
      b.hidden = false; b.classList.remove('is-gone'); b.removeAttribute('aria-hidden'); b.removeAttribute('tabindex');
      return;
    }
    if (b.hidden || b.classList.contains('is-gone')) return;
    if (document.activeElement === b && other) other.focus();
    b.classList.add('is-gone'); b.setAttribute('aria-hidden', 'true'); b.setAttribute('tabindex', '-1');
    b._shpDue = false; clearTimeout(b._shpT);
    b._shpT = setTimeout(function () { b._shpDue = true; arrowDrop(b); }, 600);
  }
  /* לחיצה על חץ שבקצה: נבלעת, לא עושה כלום */
  function goneArrow(t) { return t.classList.contains('is-gone'); }
  function goTo(i) {
    var s = slideAt(i);
    if (!s || !track) return;
    /* גלילה אופקית בתוך הגלריה בלבד, בלי להזיז את הדף. עובד גם ב-RTL. */
    var tr = track.getBoundingClientRect(), sr = s.getBoundingClientRect();
    var d = sr.left - tr.left, start = track.scrollLeft;
    var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollBy({ left: d, behavior: reduce ? 'auto' : 'smooth' });
    /* גיבוי: אם הגלילה החלקה לא זזה (דפדפן ישן, טאב ברקע), קפיצה ישירה */
    setTimeout(function () { if (track.scrollLeft === start && Math.abs(d) > 1) { track.scrollBy({ left: d }); syncUi(); } }, 450);
  }
  if (track) {
    track.addEventListener('scroll', syncUi, { passive: true });
    syncUi();
  }

  /* ===== זום ===== */
  var zbox = root.querySelector('[data-shp-zoombox]');
  var zimg = root.querySelector('[data-shp-zoomimg]');
  var zOpener = null;
  /* סבב 2 #11: חצים ומונה בתוך הזום. zIdx = התמונה שמוצגת בזום (לא תלוי בגלילה החלקה של הגלריה שמאחור). */
  var zIdx = 1;
  var zPrev = zbox ? zbox.querySelector('[data-shp-zstep="-1"]') : null;
  var zNext = zbox ? zbox.querySelector('[data-shp-zstep="1"]') : null;
  var zCur = zbox ? zbox.querySelector('[data-shp-zcur]') : null;
  var desk = window.matchMedia ? matchMedia('(min-width: 990px)') : null;
  /* התמונה הקרובה בכיוון step שיש לה גרסת זום. 0 = אין */
  function zNear(i, step) {
    for (var n = i + step; n >= 1 && n <= slides.length; n += step) {
      var s = slideAt(n);
      if (s && s.getAttribute('data-zoom')) return n;
    }
    return 0;
  }
  function openZoom(i, opener) {
    var s = slideAt(i);
    if (!s || !zbox || !s.getAttribute('data-zoom')) return;
    var wasOpen = !zbox.hidden;
    var zx = zbox.querySelector('[data-shp-zoomclose]');
    zOpener = opener || null;
    zIdx = i;
    zimg.src = s.getAttribute('data-zoom');
    var im = s.querySelector('img');
    zimg.alt = im ? im.alt : '';
    if (zCur) zCur.textContent = i;
    setOff(zPrev, !zNear(i, -1), zx);
    setOff(zNext, !zNear(i, 1), zx);
    zbox.hidden = false;
    zbox.scrollTop = 0;
    document.documentElement.style.overflow = 'hidden';
    if (!wasOpen) zx.focus();
  }
  function zStep(step) {
    var n = zNear(zIdx, step);
    if (n) { goTo(n); openZoom(n, zOpener); }
  }
  function closeZoom() {
    if (!zbox || zbox.hidden) return;
    zbox.hidden = true;
    zimg.removeAttribute('src');
    document.documentElement.style.overflow = '';
    if (zOpener) zOpener.focus();
  }

  root.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-shp-zstep], [data-shp-step]')) && goneArrow(t)) return;
    if ((t = e.target.closest('[data-shp-zstep]'))) { zStep(Number(t.getAttribute('data-shp-zstep'))); return; }
    if ((t = e.target.closest('[data-shp-step]'))) { goTo(curIndex() + Number(t.getAttribute('data-shp-step'))); return; }
    if ((t = e.target.closest('[data-shp-thumb]'))) { goTo(Number(t.getAttribute('data-shp-thumb'))); return; }
    if ((t = e.target.closest('[data-shp-zoom]'))) { openZoom(curIndex(), t); return; }
    /* תיקון לגל א (אורי 03.10): במחשב לחיצה על התמונה המוגדלת לא סוגרת. בקצה החץ נעלם, ולחיצה חוזרת באותה נקודה נפלה על התמונה וסגרה את הזום.
       סוגרים: X, Escape והרקע. בנייד אין חצים בזום, ולחיצה על התמונה סוגרת כמו קודם. */
    var zImgClose = e.target === zimg && !(desk && desk.matches);
    if (e.target.closest('[data-shp-zoomclose]') || (zbox && (zImgClose || e.target === zbox))) { closeZoom(); return; }
    /* סבב 2 #11: במחשב הזום נפתח רק מכפתור הזום. בנייד לחיצה על התמונה פותחת, כמו קודם. */
    if (!(desk && desk.matches) && (t = e.target.closest('.shp-slide[data-zoom]'))) { openZoom(Number(t.getAttribute('data-i')), null); return; }
    if ((t = e.target.closest('[data-shp-goto]'))) {
      goTo(Number(t.getAttribute('data-shp-goto')));
      var gal = root.querySelector('[data-shp-gal]');
      var top = gal.getBoundingClientRect().top + window.pageYOffset - 70;
      window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'smooth' });
    }
  });

  /* ===== מגירות (סבב 2): רכיב אחד, תוכן אחר. data-shp-open="<id>" פותח את ה-.shp-sheet עם אותו id:
     מצב (shp-grades), משלוח, החזרה, ניקוי, פריט יחיד. רקע כהה אחד, מגירה אחת פתוחה בכל רגע. ===== */
  var scrim = root.querySelector('.shp-scrim');
  var sheet = null; /* המגירה הפתוחה */
  var opener = null;
  function closeSheet() {
    if (!sheet) return;
    sheet.hidden = true; if (scrim) scrim.hidden = true;
    document.documentElement.style.overflow = '';
    if (opener) { opener.setAttribute('aria-expanded', 'false'); opener.focus(); }
    sheet = null;
  }
  root.addEventListener('click', function (e) {
    var o = e.target.closest('[data-shp-open]');
    if (o) {
      var s = document.getElementById(o.getAttribute('data-shp-open'));
      if (!s || !root.contains(s)) return;
      closeSheet();
      opener = o; sheet = s;
      o.setAttribute('aria-expanded', 'true');
      sheet.hidden = false; if (scrim) scrim.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var x = sheet.querySelector('.shp-x'); if (x) x.focus();
      /* גל ג (דנה, נמוך 5): במגירת המצב הדרגה של הפריט נגללת לתוך התצוגה (במסך נמוך היא יכולה להיות מתחת לקו הגלילה של המגירה) */
      var gc = sheet.querySelector('li[aria-current="true"]');
      if (gc && gc.scrollIntoView) gc.scrollIntoView({ block: 'nearest' });
      return;
    }
    if (e.target.closest('[data-shp-close]')) closeSheet();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeSheet(); closeZoom(); }
    /* הפוקוס נשאר בתוך השכבה הפתוחה (מגירה או זום), רק בין הכפתורים שנראים */
    var layer = sheet || (zbox && !zbox.hidden ? zbox : null);
    if (e.key === 'Tab' && layer) {
      var f = Array.prototype.filter.call(layer.querySelectorAll('button, a[href]'), function (el) { return el.getClientRects().length && !el.classList.contains('is-gone'); });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      /* גל ד (בודק הקוד): הפוקוס מחוץ לשכבה (למשל אחרי לחיצה על טקסט במגירה, שמעבירה אותו ל-body) = Tab מחזיר אותו פנימה, ולא ממשיך אל מה שמאחורי הרקע */
      if (!layer.contains(document.activeElement)) { e.preventDefault(); (e.shiftKey ? last : first).focus(); return; }
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    if (zbox && !zbox.hidden && track) {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') zStep(e.key === 'ArrowLeft' ? 1 : -1); /* RTL: שמאלה = הבאה */
    }
  });

  /* ===== שורת הדירוג (סבב 2, גל ג, #16): בשרת היא שורה שאינה לחיצה. רק אם בלוק הביקורות נמצא בדף
     (.sp-reviews, snippets/shani-google-reviews, בתחתית הדף) היא הופכת לכפתור שגולל אליו. אין בלוק = נשארת כמו שהיא. ===== */
  var rate = root.querySelector('[data-shp-rate]');
  var revs = document.querySelector('.sp-reviews');
  if (rate && revs) {
    var rb = document.createElement('button');
    rb.type = 'button'; rb.className = rate.className + ' is-link';
    rb.setAttribute('data-shp-rate', ''); rb.setAttribute('aria-label', rate.getAttribute('data-go') || rate.getAttribute('aria-label') || '');
    while (rate.firstChild) rb.appendChild(rate.firstChild);
    rate.parentNode.replaceChild(rb, rate);
    /* הגלילה לא נוחתת מתחת להדר הדביק: ההיסט הוא הגובה של מה שצמוד כרגע לראש המסך (fixed או sticky) ועוד 12px, ולפחות 70 */
    var headOff = function () {
      var el = document.elementFromPoint ? document.elementFromPoint(window.innerWidth / 2, 2) : null, h = 0;
      while (el && el !== document.body && el !== document.documentElement) {
        var ps = window.getComputedStyle ? getComputedStyle(el).position : '';
        if (ps === 'fixed' || ps === 'sticky') h = Math.max(h, el.getBoundingClientRect().bottom);
        el = el.parentElement;
      }
      return Math.max(70, Math.round(h) + 12);
    };
    /* גל ד (אורי, תקלה 4): כותרת הבלוק ("הלקוחות שלי מספרות...") יושבת מחוץ ל-.sp-reviews ומעליו, ובנייד היא נחתה מתחת להדר.
       היעד הוא הכותרת (h1 עד h6) שקודמת לבלוק, באחד משלושת ההורים שלו, אם היא נראית ועד 200px מעליו. אין כזו = הבלוק עצמו, כמו קודם. */
    var revTop = function () {
      var r = revs.getBoundingClientRect().top, best = r, a = revs.parentElement;
      for (var k = 0; k < 3 && a && a !== document.body && best === r; k++, a = a.parentElement) {
        Array.prototype.forEach.call(a.querySelectorAll('h1, h2, h3, h4, h5, h6'), function (h) {
          if (revs.contains(h) || !(h.compareDocumentPosition(revs) & 4) || !h.getClientRects().length) return;
          var t = h.getBoundingClientRect().top;
          if (t < best && r - t <= 200) best = t;
        });
      }
      return best;
    };
    rb.addEventListener('click', function () {
      var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
      var top = revTop() + window.pageYOffset - headOff();
      window.scrollTo({ top: top < 0 ? 0 : top, behavior: reduce ? 'auto' : 'smooth' });
      /* הפוקוס עובר לבלוק, כדי שמקלדת וקורא מסך ימשיכו משם */
      if (!revs.hasAttribute('tabindex')) revs.setAttribute('tabindex', '-1');
      try { revs.focus({ preventScroll: true }); } catch (e) {}
    });
  }

  /* שומר "כבר בסל": עבר ל-assets/shani-cart-guard.js (משותף לדף המוצר ולקטגוריה). */

  /* ===== פס דביק: מופיע רק אחרי שפס הקנייה הראשי יצא מהמסך למעלה ===== */
  var bar = root.querySelector('[data-shp-sbar]');
  var buy = root.querySelector('[data-shp-buyrow]');
  if (bar && buy && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      var e = en[0];
      var on = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      bar.querySelectorAll('button, a').forEach(function (el) { el.tabIndex = on ? 0 : -1; });
    }).observe(buy);
  }
  /* ===== שורות המוצרים (סבב 2, גל ב): רצועות ברוחב מלא. שתיים נבנות בשרת (עוד במידה, עוד בקטגוריה. גל ד: בדף עצמו מ-8 מוצרים, והסריקה המלאה מוחלפת כאן),
     שורת המותג מתמלאת כאן בבקשה אחת, ו"צפית לאחרונה" מהעוגייה. הכרטיס: snippets/shani-card, וכאן cardEl (אותו סימון). ===== */
  var strips = root.querySelector('[data-shp-strips]');
  if (strips) {
    var me = strips.getAttribute('data-handle');
    var noBrand = (strips.getAttribute('data-nobrand') || '').split('|');
    var reduceM = function () { return window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches; };
    var shown = function (el) { return !el.hidden && (!window.getComputedStyle || getComputedStyle(el).display !== 'none'); };
    /* רקע מתחלף: הרצועה הראשונה שנראית קרם, השנייה לבנה, וכן הלאה */
    var paint = function () {
      var n = 0;
      strips.querySelectorAll('[data-shp-strip]').forEach(function (s) { if (shown(s)) { s.classList.toggle('is-cream', n % 2 === 0); n++; } });
    };
    /* חץ בקצה: setOff, אותו עיקרון של הגלריה והזום. אם הפוקוס היה עליו, הוא עובר לחץ השני, ואם גם הוא בקצה, לשורה עצמה */
    var rowSync = function (row) {
      var w = row.parentNode, prev = w.querySelector('[data-shp-rstep="-1"]'), next = w.querySelector('[data-shp-rstep="1"]');
      if (!prev || !next) return;
      var x = Math.abs(row.scrollLeft), max = row.scrollWidth - row.clientWidth;
      var offP = x < 4, offN = x > max - 4;
      /* build-h: אותו סדר כמו בגלריה, קודם מחזירים ואז מסתירים */
      if (offP) { setOff(next, offN, row); setOff(prev, offP, offN ? row : next); }
      else { setOff(prev, offP, next); setOff(next, offN, prev); }
    };
    var syncAll = function () { strips.querySelectorAll('[data-shp-srow]').forEach(rowSync); };
    strips.addEventListener('scroll', function (e) { if (e.target.hasAttribute && e.target.hasAttribute('data-shp-srow')) rowSync(e.target); }, true);
    strips.addEventListener('click', function (e) {
      var b = e.target.closest('[data-shp-rstep]');
      if (!b || goneArrow(b)) return;
      var row = b.parentNode.querySelector('[data-shp-srow]');
      var gap = parseFloat(window.getComputedStyle ? getComputedStyle(row).columnGap : 0) || 0;
      var rtl = !window.getComputedStyle || getComputedStyle(row).direction !== 'ltr';
      /* עמוד שלם (4 כרטיסים). ב-RTL "הבאים" = גלילה שמאלה (scrollLeft שלילי) */
      row.scrollBy({ left: Number(b.getAttribute('data-shp-rstep')) * (row.clientWidth + gap) * (rtl ? -1 : 1), behavior: reduceM() ? 'auto' : 'smooth' });
    });
    window.addEventListener('resize', function () { paint(); syncAll(); });

    /* --- הכרטיס ב-JS, ל"צפית לאחרונה" ולשורת המותג. אותו סימון של snippets/shani-card.
       שורת המותג: המידה מגיעה מהשרת (q.size, q.kind, לפי snippets/shani-size), והשם מאבד את המידה שבסופו רק כשהיא שווה לשדה, כמו snippets/shani-title.
       צפית לאחרונה: products/<handle>.js לא מחזיר metafields, ולכן המידה מחולצת מסוף השם, ורק כשזה אמין:
       אותיות (XXS עד XXXL, גם טווח כמו S-M), מספר שלפניו המילה "מידה", או מספר 34 עד 42 שעומד לבדו אחרי מקף ("...לורן- 37").
       "OS" יורד מהשם ולא מוצג. אחרת השם נשאר כמו שהוא, בלי שורת מידה. --- */
    var SCALE = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', 'XXXL'];
    var splitTitle = function (title, field, kind) {
      var t = String(title == null ? '' : title).trim(), w = t.split(/\s+/);
      var parse = function (num) {
        var keep = w.length, hit = 0, push = '', rm = [], lone = false;
        for (var k = 0; k < 4 && keep >= 2; k++) {
          var core = w[keep - 1].replace(/^-+/, '').replace(/[-.]+$/, '');
          if (!core) { if (hit) lone = true; keep--; continue; }
          var parts = core.split('-'), pre = '', inS = false, bad = false, got = [];
          for (var i = 0; i < parts.length; i++) {
            var p = parts[i], ok = num ? /^[\d.]{2,4}$/.test(p) && /\d/.test(p) : (SCALE.indexOf(p.toUpperCase()) > -1 || p.toUpperCase() === 'OS');
            if (ok) { inS = true; got.push(p.toUpperCase()); } else if (inS) bad = true; else pre += p + '-';
          }
          if (bad || !got.length) break;
          hit++; keep--; rm = got.concat(rm);
          if (pre) { push = pre; break; }
        }
        if (!hit) return null;
        var out = w.slice(0, keep).join(' ') + (push ? ' ' + push : ''), marker = false, dash = lone;
        for (var q = 0; q < 4; q++) {
          out = out.trim();
          var m = out.match(/(?:^|\s)(מידה|במידה|-)$/) || out.match(/-מידה$/);
          if (m) { if (m[0].indexOf('מידה') > -1) marker = true; out = out.slice(0, out.length - m[0].length); continue; }
          if (out.slice(-1) === '-') { if (!push) dash = true; out = out.slice(0, -1); continue; }
          break;
        }
        out = out.trim();
        return out ? { name: out, parts: rm, marker: marker, dash: dash } : null;
      };
      var keepT = { name: t, size: '', cut: false };
      /* מידה מהשרת: משווים את מה שבסוף השם לשדה. שווה = השם בלי המידה. לא שווה או אין = השם כמו שהוא, והמידה מהשדה */
      if (field != null) {
        var f = String(field), fr = parse(kind === 'num'), eq = false;
        if (!f) { fr = parse(false); return fr && fr.parts.length === 1 && fr.parts[0] === 'OS' ? { name: fr.name, size: '', cut: true } : keepT; }
        if (fr && kind !== 'num') {
          var rng = function (a) { var x = a.map(function (p) { return SCALE.indexOf(p); }); return x.indexOf(-1) > -1 || x.some(function (v) { return v > 6; }) ? '' : Math.min.apply(null, x) + '-' + Math.max.apply(null, x); };
          var ra = rng(fr.parts), rb = rng(f.toUpperCase().split('-'));
          eq = !!ra && ra === rb;
        } else if (fr) eq = fr.parts.join('-') === f.replace(/,/g, '-').replace(/\s+/g, '').toUpperCase();
        return eq ? { name: fr.name, size: f, cut: true } : { name: t, size: f, cut: false };
      }
      var r = parse(false);
      if (r) {
        if (r.parts.length === 1 && r.parts[0] === 'OS') return { name: r.name, size: '', cut: true };
        if (r.parts.indexOf('OS') < 0) {
          var ix = r.parts.map(function (p) { return SCALE.indexOf(p); });
          var lo = Math.min.apply(null, ix), hi = Math.max.apply(null, ix);
          return { name: r.name, size: lo === hi ? SCALE[lo] : SCALE[lo] + '-' + SCALE[hi], cut: true };
        }
      } else {
        r = parse(true);
        var shoeNum = r && r.dash && r.parts.every(function (p) { return /^\d\d(\.5)?$/.test(p) && Number(p) >= 34 && Number(p) <= 42; });
        if (r && (r.marker || shoeNum)) return { name: r.name, size: r.parts.join('-'), cut: true };
      }
      return keepT;
    };
    var mk = function (tag, cls, text) { var el = document.createElement(tag); if (cls) el.className = cls; if (text != null) el.textContent = text; return el; };
    /* מחיר: מספרים בלבד, ולכן innerHTML. window.shaniMoneyHTML מ-snippets/shani-tokens, ואם עוד לא נטען, אותו סימון כאן */
    var mh = function (c, o) { o = o || {}; if (window.shaniMoneyHTML) return window.shaniMoneyHTML(c, o); var t = o.was ? 's' : 'span'; return '<' + t + ' class="sp-m' + (o.was ? ' sp-was' : '') + (o.cls ? ' ' + o.cls : '') + '" dir="rtl"><span class="sp-m__n" dir="ltr">' + String(Math.round(c / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '</span><span class="sp-m__c">₪</span></' + t + '>'; };
    /* כל ערך מהמוצר נכנס כ-textContent או כמאפיין, לא כ-HTML */
    var cardEl = function (q) {
      var a = mk('a', 'shp-card');
      a.setAttribute('href', q.url); a.setAttribute('data-h', q.handle);
      if (q.featured_image) {
        var fi = String(q.featured_image).replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
        var u = function (n) { return fi + (fi.indexOf('?') > -1 ? '&' : '?') + 'width=' + n; };
        var im = mk('img', 'shp-card-img');
        im.setAttribute('src', u(564)); im.setAttribute('srcset', [150, 300, 450, 564].map(function (n) { return u(n) + ' ' + n + 'w'; }).join(', '));
        im.setAttribute('sizes', '(min-width: 1248px) 282px, (min-width: 990px) calc((100vw - 120px) / 4), 148px'); im.setAttribute('alt', ''); im.setAttribute('loading', 'lazy'); im.setAttribute('decoding', 'async');
        /* 3:4, כמו המסגרת ב-CSS (aspect-ratio: 3/4, contain): המקום נשמר לפני שהתמונה נטענת */
        im.setAttribute('width', '564'); im.setAttribute('height', '752');
        a.appendChild(im);
      }
      var v = String(q.vendor == null ? '' : q.vendor).trim();
      if (v && noBrand.indexOf(v.toUpperCase()) < 0) { var b = mk('span', 'shp-card-b'); b.appendChild(mk('bdi', '', v)); a.appendChild(b); }
      var st = splitTitle(q.title, q.size, q.kind), n = mk('span', 'shp-card-n');
      if (st.cut && st.size) n.textContent = st.name;
      else {
        /* כמו shani-title בלי שדה מידה: המילה האחרונה (והמילה שלפניה, אם נגמרת במקף או ב"מידה") לא נשברת בין שורות */
        var w = st.name.split(/\s+/), cut = w.length - 1;
        if (w.length > 1 && /(-|מידה)$/.test(w[w.length - 2])) cut = w.length - 2;
        if (cut > 0) n.appendChild(document.createTextNode(w.slice(0, cut).join(' ') + ' '));
        var tail = mk('span', '', w.slice(cut).join(' ')); tail.setAttribute('style', 'white-space:nowrap'); n.appendChild(tail);
      }
      a.appendChild(n);
      if (st.size) { var s = mk('span', 'shp-card-s', 'מידה '); s.appendChild(mk('bdi', '', st.size)); a.appendChild(s); }
      var pr = mk('span', 'shp-price'), price = Number(q.price) || 0, was = Number(q.compare_at_price) || 0;
      pr.innerHTML = was > price ? mh(price, { cls: 'shp-now shp-now--disc' }) + mh(was, { was: true, cls: 'shp-was' }) : mh(price, { cls: 'shp-now' });
      a.appendChild(pr);
      return a;
    };
    root.shpCardEl = cardEl; root.shpPaint = function () { paint(); syncAll(); }; /* משמשים את "צפית לאחרונה" למטה (לא למחוק). harness/render-wave-b.js משווה דרכם את הכרטיס הזה לכרטיס של ליקוויד */

    var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var toks = function (v) { return String(v == null ? '' : v).split(',').map(function (x) { return x.replace(/^size_/, '').trim().toLowerCase(); }).filter(Boolean); };
    var can = !!(window.fetch && window.DOMParser && window.Promise);
    var secUrl = function (u, id) { return u + (u.indexOf('?') > -1 ? '&' : '?') + 'section_id=' + id; };
    var getText = function (u) { return fetch(u, { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.text() : ''; }); };
    /* has-brand (בנייד מסתיר את שורת הקטגוריה): שורת מותג שנבנתה בשרת, או המקום השמור של שורת המותג כל עוד הוא מוצג */
    var brandSync = function () {
      var live = strips.querySelector('[data-shp-brand]');
      strips.classList.toggle('has-brand', !!strips.querySelector('[data-shp-brand-srv]') || !!(live && !live.hidden));
    };
    brandSync();

    /* --- גל ד (ביצועים): הסריקה המלאה של שורות השרת. בדף עצמו הן נבנות מ-8 המוצרים הראשונים של הקולקציה בלבד
       (כדי ש-250 מוצרים לא יירשמו בבלוק האנליטיקה שב-head). כשזה לא הספיק (data-shp-rows-more), בקשה אחת ל-sections/shani-product-rows
       על כתובת המוצר מחזירה את אותן שורות מסריקה של 250, וכאן הן מחליפות את מה שמסומן data-shp-srv. המקום השמור של שורת המותג ו"צפית לאחרונה" לא זזים.
       הכותרות ותוויות החצים מועתקות מהדף (data-shp-rt, והחצים של "צפית לאחרונה"): הסקשן ההוא לא מכיר את המחרוזות.
       לא מחליפים: תשובה ריקה או שבורה, קולקציית סוג אחרת מזו של הדף (data-type), או כשהפוקוס כבר בתוך שורה קיימת. אז השורות של הדף נשארות. --- */
    var rowsUrl = can && strips.querySelector('[data-shp-rows-more]') ? strips.getAttribute('data-rows') : '';
    var rowsSwap = function (html) {
      var box = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-shp-rows]');
      if (!box || box.getAttribute('data-type') !== strips.getAttribute('data-type') || box.getAttribute('data-handle') !== me) return;
      var act = document.activeElement;
      if (act && act.closest && act.closest('[data-shp-srv]')) return;
      var rvS = strips.querySelector('[data-shp-rv]'), fresh = [];
      Array.prototype.forEach.call(box.querySelectorAll('[data-shp-srv]'), function (el) {
        var k = (el.className.match(/shp-strip--(size|brand|cat|more)/) || [])[1];
        if (!k) return;
        var src = strips.querySelector('[data-shp-rt="' + (k === 'more' ? 'cat' : k) + '"]'), to = el.querySelector('.shp-strip-h, .shp-more a');
        if (!src || !to) return;
        to.textContent = '';
        Array.prototype.forEach.call(src.childNodes, function (n) { to.appendChild(n.cloneNode(true)); });
        Array.prototype.forEach.call(el.querySelectorAll('[data-shp-rstep]'), function (bt) {
          var o = rvS && rvS.querySelector('[data-shp-rstep="' + bt.getAttribute('data-shp-rstep') + '"]');
          if (o) bt.setAttribute('aria-label', o.getAttribute('aria-label'));
        });
        fresh.push([k, el]);
      });
      if (!fresh.length) return;
      Array.prototype.forEach.call(strips.querySelectorAll('[data-shp-srv]'), function (el) { el.parentNode.removeChild(el); });
      var anchor = strips.querySelector('[data-shp-brand]') || rvS;
      fresh.forEach(function (x) { strips.insertBefore(x[1], x[0] === 'size' ? anchor : rvS); });
      brandSync();
    };

    /* --- שורת המותג (#9). פריט עם מידה: בקשה אחת ל-sections/shani-brand-row על דף הספק.
       חוזר JSON קטן: [handle, שם, תמונה, מחיר, מחיר מחוק, תווית מידה, סוג, מידות]. כאן: בלי הפריט עצמו, בלי מה שכבר מוצג בשורת המידה,
       רק במידה של הפריט (בנעליים מספיקה מידה אחת משותפת), עד 8, והכרטיסים נבנים ב-cardEl. פחות מ-3 = אין שורה.
       בזמן הטעינה השלד שומר את הגובה. בנייד שורת הקטגוריה מוסתרת כל עוד שורת המותג מוצגת או נטענת (has-brand), ואם אין שורת מותג היא חוזרת באותו מקום.
       פריט בלי מידה: השורה נבנית בשרת מאותה קולקציית סוג (data-shp-brand-srv), בלי הבקשה הזו.
       גל ד: השורה מתמלאת רק אחרי ששורות השרת הוחלפו (היא מסננת מול שורת המידה הסופית). בקשה שנתקעת 8 שניות = השורה יורדת. --- */
    var br = strips.querySelector('[data-shp-brand]'), burl = br ? br.getAttribute('data-url') : '', brDone = false, brT = 0;
    var brOff = function () {
      if (!br || brDone) return;
      brDone = true; clearTimeout(brT);
      br.hidden = true; br.removeAttribute('aria-busy'); brandSync(); paint(); syncAll();
    };
    var brFill = function (html) {
      if (brDone) return;
      var brRow = br.querySelector('[data-shp-srow]');
      var sc = new DOMParser().parseFromString(html, 'text/html').querySelector('script[data-shp-br]');
      var items = sc ? JSON.parse(sc.textContent) : [];
      var have = Object.create(null); have[me] = 1;
      strips.querySelectorAll('.shp-strip--size .shp-card[data-h]').forEach(function (c) { have[c.getAttribute('data-h')] = 1; });
      var want = toks(br.getAttribute('data-sz')), kind = want.length ? 'abc' : 'num';
      if (!want.length) want = toks(br.getAttribute('data-shoe'));
      var vendor = br.getAttribute('data-vendor') || '', pick = [];
      items.forEach(function (it) {
        if (!it || have[it[0]] || pick.length >= 8 || it[6] !== kind) return;
        var mine = toks(it[7]);
        if (want.some(function (k) { return mine.indexOf(k) > -1; })) { have[it[0]] = 1; pick.push(it); }
      });
      if (pick.length < 3) { brOff(); return; }
      brDone = true; clearTimeout(brT);
      brRow.textContent = '';
      pick.forEach(function (it) { brRow.appendChild(cardEl({ handle: it[0], url: rootUrl + 'products/' + it[0], title: it[1], vendor: vendor, featured_image: it[2], price: it[3], compare_at_price: it[4], size: it[5], kind: it[6] })); });
      br.removeAttribute('aria-busy');
      /* ביטחון: פריט שמוצג בשורת המותג לא חוזר בשורת הקטגוריה. נשאר שם פחות מ-2: היא יורדת */
      var cat = strips.querySelector('.shp-strip--cat');
      if (cat) {
        cat.querySelectorAll('.shp-card[data-h]').forEach(function (c) { if (pick.some(function (x) { return x[0] === c.getAttribute('data-h'); })) c.remove(); });
        if (cat.querySelectorAll('.shp-card').length < 2) cat.hidden = true;
      }
      paint(); syncAll();
    };
    if (br && (!can || !burl)) brOff();
    else if (br) { br.hidden = false; brandSync(); paint(); }

    /* --- העיתוי (גל ד, אורי תקלה 3): שתי הבקשות (שורות השרת ושורת המותג) יוצאות יחד, ורק אחרי ששני התנאים מתקיימים:
       1. הדף סיים להיטען (load, כולל התמונה הראשית) והדפדפן פנוי (requestIdleCallback). כך הן לא מתחרות בתמונה הראשית.
       2. הרצועות במרחק של עד 200px מהתצוגה (היה 800px, ולכן ברוב הדפים הבקשה יצאה בטעינה).
       במסך גבוה שבו הרצועות כבר ליד התצוגה בלי גלילה, הבקשות יוצאות מיד אחרי load. בלי IntersectionObserver: אחרי load. --- */
    if (can && (rowsUrl || (br && !brDone))) {
      var rowsLoad = function () {
        var rowsP = rowsUrl ? getText(secUrl(rowsUrl, 'shani-product-rows')).then(rowsSwap).catch(function () {}) : Promise.resolve();
        var brP = br && !brDone ? getText(secUrl(burl, 'shani-brand-row')) : null;
        if (brP) { brP.catch(function () {}); brT = setTimeout(brOff, 8000); }
        rowsP.then(function () {
          paint(); syncAll();
          if (brP) brP.then(brFill).catch(brOff);
        });
      };
      var rowsArm = function () {
        if (!('IntersectionObserver' in window)) { rowsLoad(); return; }
        var io = new IntersectionObserver(function (en) {
          if (io && en.some(function (x) { return x.isIntersecting; })) { io.disconnect(); io = null; rowsLoad(); }
        }, { rootMargin: '200px 0px' });
        io.observe(strips);
      };
      var rowsIdle = function () { if (window.requestIdleCallback) requestIdleCallback(rowsArm, { timeout: 2000 }); else setTimeout(rowsArm, 1); };
      if (document.readyState === 'complete') rowsIdle(); else window.addEventListener('load', rowsIdle);
    }
    paint(); syncAll();
  }

  /* ===== צפית לאחרונה (סבב 5): אותה עוגייה ואותו פורמט של Halo (ידיות מופרדות ברווח, 16 אחרונות, 90 יום),
     כדי שהחלון הקופץ של Halo ימשיך לעבוד. סבב 2, גל ב: רצועה ברוחב מלא, והכרטיס של שאר הרצועות (cardEl). ===== */
  var rv = root.querySelector('[data-shp-rv]');
  if (rv && strips) {
    var RVC = 'shopify_recently_viewed';
    var readRv = function () {
      var m = document.cookie.match(/(?:^|;\s*)shopify_recently_viewed=([^;]*)/);
      if (!m || !m[1]) return [];
      try { return decodeURIComponent(m[1]).split(' ').filter(Boolean); } catch (e) { return []; }
    };
    var list = readRv();
    var prev = list.filter(function (h) { return h !== me; });
    var mine = [me].concat(prev).slice(0, 16); /* 5b: 16 ולא 10, כדי שאחרי סינון הנמכרים יישארו 8 */
    var exp = new Date(Date.now() + 90 * 864e5).toUTCString();
    document.cookie = RVC + '=' + encodeURIComponent(mine.join(' ')) + '; expires=' + exp + '; path=/; domain=' + location.hostname;
    var show = prev.slice(0, 12); /* 5b: מושכים עד 12, מסננים את מה שלא זמין, ורק אז חותכים ל-8 */
    if (show.length && window.fetch) {
      var rvRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      Promise.all(show.map(function (h) {
        return fetch(rvRoot + 'products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (ps) {
        var row = rv.querySelector('[data-shp-srow]'), n = 0;
        ps.filter(function (q) { return q && q.available; }).slice(0, 8).forEach(function (q) { row.appendChild(root.shpCardEl(q)); n++; });
        if (n) { rv.hidden = false; root.shpPaint(); }
      });
    }
  }
})();
